module.exports = {
  "dof-badge": {
    "position": "absolute",
    "right": 0,
    "top": 0
  },
  "dof-badge-text-small": {
    "height": "30",
    "paddingTop": 0,
    "paddingRight": "8",
    "paddingBottom": 0,
    "paddingLeft": "8",
    "borderRadius": "15",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "dof-badge-text-default": {
    "height": "36",
    "paddingTop": 0,
    "paddingRight": "10",
    "paddingBottom": 0,
    "paddingLeft": "10",
    "borderRadius": "18",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "text-desc": {
    "textAlign": "center",
    "color": "#ffffff"
  },
  "text-desc-default": {
    "fontSize": "24",
    "minWidth": "16",
    "textAlign": "center"
  },
  "text-desc-small": {
    "fontSize": "20",
    "minWidth": "14",
    "textAlign": "center"
  },
  "dof-badge-dot-default": {
    "width": "16",
    "height": "16",
    "borderRadius": "16"
  },
  "dof-badge-dot-small": {
    "width": "12",
    "height": "12",
    "borderRadius": "12"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1ff3d940!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-badge/index.vue
// module id = 436
// module chunks = 0 1